// Libraries
import React, { useContext, Fragment } from 'react';

// Components
import OverallRatingDiagram from './OverallRatingDiagram';

// Services and Contexts
import LanguageContext from '../../../contexts/LanguageContext';
import RatingsContext from '../../../contexts/RatingsContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export default function OverallRating({ userRating }) {
  const { translate, language } = useContext(LanguageContext);
  const { ratings } = useContext(RatingsContext);

  const renderInformation = () => {
    if (ratings.overall)
      return (
        <Fragment>
          <Typography variant="body1" paragraph>
            {translate('SCREEN_RESULTS_OVERALL_RATING_DESCRIPTION')}
            <strong> {ratings.overall.levels[userRating].name[language]}.</strong>
          </Typography>
          <Typography variant="body1" paragraph>
            {ratings.overall.levels[userRating].description[language]}
          </Typography>
          <Typography variant="body1" paragraph>
            {ratings.overall.levels[userRating].recommendations[language]}
          </Typography>
        </Fragment>
      );
  };

  const translateLabels = () => {
    if (ratings.overall) {
      const labels = {};
      for (const key in ratings.overall.diagram) {
        labels[key] = ratings.overall.diagram[key][language];
      }
      return labels;
    }
    return;
  };

  const renderDiagram = () => {
    const labels = translateLabels();
    return (
      <Box mx="auto" mt={4} mb={8}>
        <OverallRatingDiagram width={'500px'} gmgLevel={userRating} {...labels} />
      </Box>
    );
  };

  return (
    <Box textAlign="left" px={4}>
      <Typography variant="h6" gutterBottom>
        <strong>{translate('SCREEN_RESULTS_OVERALL_RATING_TITLE')}</strong>
      </Typography>
      {renderInformation()}
      {renderDiagram()}
    </Box>
  );
}
